<template>
  <div>
    <v-breadcrumbs :items="lists">

    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  data: () => ({
    lists: []
  }),
  created() {
    this.replace(this.$route)
  },
  watch: {
    $route(to) {
      this.replace(to)
    }
  },
  methods: {
    replace(item) {
      this.lists = []
      let {path, matched} = item

      matched.forEach(_item => {
        this.lists.push({
          text: _item.meta.title,
          href: _item.path,
          disabled: path == _item.path
        })
      })
    }

  }

}
</script>

<style scoped>

</style>